// Payment System v3.0 PR 9 — Phoenix-Backed Resale workflow API client
// (design spec §8.5). All endpoints are loan-scoped — the loan id is the
// existing Buyer Note for the resale endpoints and the Spread Note for the
// mature-bridge / financial-closing endpoints.

import { api } from "@/api/client";
import type {
  FinancialClosingPreview,
  FinancialClosingRequest,
  FinancialClosingResponse,
  MatureBridgeResponse,
  ResaleClosingExecuteRequest,
  ResaleClosingPreview,
  ResaleClosingPreviewRequest,
  ResaleClosingResponse,
  ResaleLinkResponse,
} from "@/types/resale";

export const resaleApi = {
  previewResale: (loanId: string, body: ResaleClosingPreviewRequest) =>
    api.post<ResaleClosingPreview>(`/loans/${loanId}/resale/preview`, body),

  executeResale: (loanId: string, body: ResaleClosingExecuteRequest) =>
    api.post<ResaleClosingResponse>(`/loans/${loanId}/resale`, body),

  matureBridge: (spreadNoteLoanId: string) =>
    api.post<MatureBridgeResponse>(`/loans/${spreadNoteLoanId}/mature-bridge`, {}),

  previewFinancialClosing: (
    spreadNoteLoanId: string,
    body: FinancialClosingRequest,
  ) =>
    api.post<FinancialClosingPreview>(
      `/loans/${spreadNoteLoanId}/financial-closing/preview`,
      body,
    ),

  executeFinancialClosing: (
    spreadNoteLoanId: string,
    body: FinancialClosingRequest,
  ) =>
    api.post<FinancialClosingResponse>(
      `/loans/${spreadNoteLoanId}/financial-closing`,
      body,
    ),

  getResaleLink: (loanId: string) =>
    api.get<ResaleLinkResponse>(`/loans/${loanId}/resale-link`),
};
